<div class="generic-after-attendee-card" [class.hide]='type === AfterAttendeeSectionType.SOCIAL_MEDIA && !getSocialMediaSection()'>
  <div class="card-body">
    <div class="icon" [innerHTML]="getIcon() | safeHtml">

    </div>
    <div class="content">
      <div class="info">
        <div class="card-title">
          {{ getTitle() }}
        </div>
        <div class="card-description">
          {{ getDescription() }}
        </div>
      </div>
      @if(type === AfterAttendeeSectionType.SOCIAL_MEDIA){
        <app-edit-social-media-buttons
          [section]="getSocialMediaSection()"
          [isEditMode]="false"
        />
      }
    </div>
  </div>
  @if(type === AfterAttendeeSectionType.SIGN_UP){
    <button class="btn btn-primary-outline action-button-card" (click)="goToSignUp()">{{ "APP.EVENT_AFTER_ATTEND.GENERIC.SIGN_UP_NOW" | translate }}</button>
  }

</div>
